import {
  triggerActionLocoKeys,
  triggerDescriptionLocoKeys,
} from 'modules/automation-rules/triggers/constants/trigger-loco-keys'
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import { getTriggerIcon } from 'modules/automation-rules/triggers/utils/get-trigger-icon'
import type { JSX } from 'react'

const triggerCategoryLocoKeys = {
  contact: 'dashboard.automation_rule.category.contact',
  formsAndSubscriptions: 'dashboard.automation_rule.category.forms_and_subscriptions',
  courses: 'dashboard.automation_rule.category.courses',
  sales: 'dashboard.automation_rule.category.sales',
  email: 'dashboard.automation_rule.category.email',
  events: 'dashboard.automation_rule.category.events',
  community: 'dashboard.automation_rule.category.community',
  tracking: 'dashboard.automation_rule.category.tracking',
} as const

export const triggerCategoryOrder = Object.values(triggerCategoryLocoKeys)

type TriggerCategory = (typeof triggerCategoryLocoKeys)[keyof typeof triggerCategoryLocoKeys]

const triggerCategoryBySlug = {
  [AutomationRuleTriggersEnum.tag_added]: triggerCategoryLocoKeys.contact,
  [AutomationRuleTriggersEnum.tag_removed]: triggerCategoryLocoKeys.contact,
  [AutomationRuleTriggersEnum.form_subscribed]: triggerCategoryLocoKeys.formsAndSubscriptions,
  [AutomationRuleTriggersEnum.blog_page_form_subscribed]:
    triggerCategoryLocoKeys.formsAndSubscriptions,
  [AutomationRuleTriggersEnum.website_form_subscribed]:
    triggerCategoryLocoKeys.formsAndSubscriptions,
  [AutomationRuleTriggersEnum.digital_store_form_subscribed]:
    triggerCategoryLocoKeys.formsAndSubscriptions,
  [AutomationRuleTriggersEnum.enrolled_in_course]: triggerCategoryLocoKeys.courses,
  [AutomationRuleTriggersEnum.course_completed]: triggerCategoryLocoKeys.courses,
  [AutomationRuleTriggersEnum.module_completed]: triggerCategoryLocoKeys.courses,
  [AutomationRuleTriggersEnum.lecture_completed]: triggerCategoryLocoKeys.courses,
  [AutomationRuleTriggersEnum.enrolled_in_course_bundle]: triggerCategoryLocoKeys.courses,
  [AutomationRuleTriggersEnum.new_sale]: triggerCategoryLocoKeys.sales,
  [AutomationRuleTriggersEnum.sale_canceled]: triggerCategoryLocoKeys.sales,
  [AutomationRuleTriggersEnum.subscription_payment_failed]: triggerCategoryLocoKeys.sales,
  [AutomationRuleTriggersEnum.email_opened]: triggerCategoryLocoKeys.email,
  [AutomationRuleTriggersEnum.email_link_clicked]: triggerCategoryLocoKeys.email,
  [AutomationRuleTriggersEnum.campaign_completed]: triggerCategoryLocoKeys.email,
  [AutomationRuleTriggersEnum.booking_created]: triggerCategoryLocoKeys.events,
  [AutomationRuleTriggersEnum.registered_to_webinar]: triggerCategoryLocoKeys.events,
  [AutomationRuleTriggersEnum.enrolled_in_community]: triggerCategoryLocoKeys.community,
  [AutomationRuleTriggersEnum.page_visited]: triggerCategoryLocoKeys.tracking,
} satisfies Record<AutomationRuleTriggersEnum, TriggerCategory>

export interface TriggerItem {
  category: TriggerCategory
  slug: AutomationRuleTriggersEnum
  title: string
  description: string
  icon: JSX.Element
}

export const triggerItems: TriggerItem[] = Object.values(AutomationRuleTriggersEnum).map(slug => ({
  category: triggerCategoryBySlug[slug],
  slug: slug,
  title: triggerActionLocoKeys[slug],
  description: triggerDescriptionLocoKeys[slug],
  icon: getTriggerIcon(slug),
}))
